import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "./cn";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "sm" | "md" | "lg";
}

const SIZES = {
  sm: "h-8 w-8 text-base",
  md: "h-10 w-10 text-lg",
  lg: "h-12 w-12 text-xl",
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, size = "md", "aria-label": ariaLabel, ...props }, ref) => {
    if (!ariaLabel) {
      console.warn("IconButton: aria-label is required for accessibility");
    }
    return (
      <button
        ref={ref}
        aria-label={ariaLabel}
        className={cn(
          "inline-flex items-center justify-center rounded-full",
          "text-ink-muted hover:text-ink hover:bg-surface-muted",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2",
          "transition-colors",
          SIZES[size],
          className,
        )}
        {...props}
      />
    );
  },
);
IconButton.displayName = "IconButton";
